import { useMemo } from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';
import { MarkingNotification } from '@/hooks/use-marking-notifications';

interface MarkingTypeDistributionChartProps {
  data: MarkingNotification[];
}

const COLORS = ['hsl(var(--primary))', 'hsl(var(--chart-2))'];

export function MarkingTypeDistributionChart({ data }: MarkingTypeDistributionChartProps) {
  const chartData = useMemo(() => {
    const fuelCount = data.filter(n => n.marking_type === 'fuel').length;
    const odometerCount = data.filter(n => n.marking_type === 'odometer').length;

    return [
      { name: 'Abastecimentos', value: fuelCount },
      { name: 'Marcações KM', value: odometerCount },
    ];
  }, [data]);

  if (data.length === 0) {
    return (
      <div className="flex items-center justify-center h-[300px] text-muted-foreground">
        Nenhum dado disponível
      </div>
    );
  }

  return (
    <ResponsiveContainer width="100%" height={300}>
      <PieChart>
        <Pie
          data={chartData}
          cx="50%"
          cy="50%"
          labelLine={false}
          label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
          outerRadius={80}
          fill="#8884d8"
          dataKey="value"
        >
          {chartData.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
          ))}
        </Pie>
        <Tooltip 
          contentStyle={{
            backgroundColor: 'hsl(var(--popover))',
            border: '1px solid hsl(var(--border))',
            borderRadius: '0.5rem',
          }}
        />
        <Legend />
      </PieChart>
    </ResponsiveContainer>
  );
}
